import React, { useState } from 'react';
import '../styles/Convocatorias.css';
/*Componentes Convocatorias*/
import Nombramiento_I_2025 from './Nombramientos/NombramientoI2025';


function Nombramientos(){

  const [casActivo, setCasActivo] = useState('Nombramiento I 2025');
  
  const casData = {
    'Nombramiento I 2025': Nombramiento_I_2025,
  };

  return (
    <div className='cas-wrapper'>
      <div className='cas-sidebar'>
        {Object.keys(casData).map((cas) => (
          <button
            key={cas}
            className={`cas-btn ${casActivo === cas ? 'activo' : ''}`}
            onClick={() => setCasActivo(cas)}
          >
            {cas}
          </button>
        ))}
      </div>
      <div className='cas-content'>
        {casData[casActivo] && React.createElement(casData[casActivo])}
      </div>
    </div>
  );
};

export default Nombramientos;


